import { Flex, Input, Text } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

interface TotalHoursInputProps {
  formRef: UseFormReturnType<any>;
}

export const HOURS_REGEX = /^-?\d+:[0-5]\d$/;

/** Controlled by the form, so reset()/errors always match what is on screen. */
function TotalHoursInput({ formRef }: TotalHoursInputProps) {
  const value: string = formRef.values.entryHours ?? '';
  const error =
    formRef.errors.entryHours ??
    (value && !HOURS_REGEX.test(value)
      ? 'Use HH:MM (ex: 142:18 ou -142:18)'
      : null);

  return (
    <Flex direction={'column'} gap={'sm'}>
      <Text size={'md'}>Total de Horas</Text>
      <Input
        type="text"
        value={value}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          formRef.setFieldValue('entryHours', e.target.value)
        }
        placeholder="ex: 142:18 (use - para debitar: -2:30)"
      />
      {error && <small style={{ color: 'red' }}>{error}</small>}
    </Flex>
  );
}

export default TotalHoursInput;
